import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Layout from "../components/Layout";

const AuthMiddleware = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("authUser");

  const layoutExcludedRoutes = [
    "/subscription",
    "/welcome",
    "/organization-information",
    "/redirectUrl",
    "/pick-a-plan",
  ];

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Layout>{children}</Layout>;
};

export default AuthMiddleware;
